/** A failure's message for people to read, without the wrapper Electron adds to IPC errors. */
export const errorMessage = (failure: unknown, fallback: string) =>
  failure instanceof Error && failure.message
    ? failure.message.replace(/^Error invoking remote method '[^']+': (?:Error: )?/, '')
    : fallback;
